import React from "react";
import { FAQS } from "../constants";

export default function KontakFaqAccordion() {
  return (
    <div className="max-w-4xl mx-auto border-t border-slate-200 dark:border-slate-800 pt-16">
      <div className="text-center mb-10">
        <span className="text-xs font-bold uppercase tracking-wider text-primary bg-primary-light dark:bg-primary/20 border border-primary/20 px-3.5 py-1.5 rounded-lg inline-block mb-2">
          ❓ Pertanyaan Umum
        </span>
        <h3 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-white">
          Pertanyaan Seputar Layanan WhatsApp
        </h3>
      </div>

      <div className="grid gap-4">
        {FAQS.map((faq, idx) => (
          <div
            key={idx}
            className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-5 shadow-sm"
          >
            <h4 className="text-sm font-bold text-slate-900 dark:text-white mb-2 flex items-start gap-2">
              <span className="text-emerald-500 font-extrabold">Q:</span>
              <span>{faq.q}</span>
            </h4>
            <p className="text-xs sm:text-sm text-slate-600 dark:text-slate-400 leading-relaxed pl-5">
              {faq.a}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
